<script>
    import {_, locale, locales, getLocaleFromHash, getLocaleFromNavigator} from "svelte-i18n"
    let selectedLanguage = getLocaleFromHash('lang') ?? getLocaleFromNavigator();
    $: {
        locale.set(selectedLanguage);
    }
</script>


<div>
    {#each $locales as ln}
        <input type="radio" bind:group={selectedLanguage} name="language" id="language-{ln}" value={ln}>
        <label for="language-{ln}">
            {ln}
        </label>
    {/each}
</div>

<style>
    div {
        display: flex;
        margin: 1rem;
        border: 3px solid #0d8bd9 ;
        border-radius: 5px;
        width: max-content;
        padding: 0
    }
    
    input[type=radio] {
        appearance: none;
        display: none;
    }
    
    label {
        display: inline-flex;
        justify-content: center;
        align-content: center;
        margin: 0;
        background: #0d8bd9;
        width: 2em;
        height: 1.5rem;
        color: white;
    }

    input[type="radio"]:checked+label {
        background: #1da1f2 !important;
    }
    
</style>